import styled, { css } from "styled-components";
import { themedNav, ThemedNavProps } from "./themedNav";
import Icon from "@icon-park/react/es/all";

/** The notification bell's own box, so the pair reads as one control each. */
const BELL_BUTTON_SIZE = 36;

export const NavChildrenContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  height: 100%;
`;

export const FloatingMenuContainer = styled.div<{ isOpen?: boolean }>`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 21px;
  cursor: pointer;
  white-space: nowrap;
  min-width: 140px;
  /* The bar is already the raised plane, so an open trigger has to recess to read as active. */
  background-color: ${({ theme, isOpen }) =>
    isOpen ? theme.colors.ui.background.inset : "transparent"};
`;

export const MenuContainer = styled.div`
  position: absolute;
  min-width: 200px;
  right: 0;
  top: calc(100% + 0px);
`;

export const HowItWorksButton = styled.button`
  display: flex;
  gap: 4px;
  white-space: nowrap;
  background: transparent;
  border: none;
  cursor: pointer;
`;

export const StyledIcon = styled(Icon)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NavigationBarContainer = styled.div<ThemedNavProps>`
  z-index: ${({ theme }) => theme.zIndex.sticky};

  ${themedNav}
`;

/**
 * Membership as the design system's chip: a rocket glyph and an amber label on
 * an amber tint. Amber is reserved for time pressure, which a renewal is.
 */
export const MemberPerksPill = styled.button<{ $iconOnly?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.space["3xs"]}px;
  padding: ${({ theme }) => theme.space["3xs"]}px
    ${({ theme }) => theme.space.md}px;
  border: none;
  border-radius: ${({ theme }) => theme.radius.sm}px;
  cursor: pointer;
  white-space: nowrap;
  background: ${({ theme }) =>
    theme.colors.domainSpecific.badgeTypes.warning.background};
  color: ${({ theme }) => theme.colors.ui.text.warning};

  &:hover {
    opacity: ${({ theme }) => theme.opacity["pressed-subtle"]};
  }

  /* A member has the perks already, so the label goes and what is left matches
     the notification bell beside it rather than sitting as a wider chip. */
  ${({ $iconOnly, theme }) =>
    $iconOnly &&
    css`
      justify-content: center;
      width: ${BELL_BUTTON_SIZE}px;
      height: ${BELL_BUTTON_SIZE}px;
      padding: 0;
      border-radius: ${theme.radius.full}px;
      /* The bell carries no fill on this bar, so neither does this. */
      background: transparent;
      color: ${theme.colors.ui.icon.onColor};
    `}
`;
